export default "__VITE_ASSET__CgZDf0TP__"